export interface ISettingsModel {
  confirmation: {
    autoConfirmEnabled: boolean;
    pendingFactTtlMinutes: number;
  };
  parkingDisplay: {
    showOverload: boolean;
  };
  fines: {
    sessionMinFixations: number;
    sessionMaxGapMinutes: number;
    enforceSameVrp: boolean;
    payGraceMinutes: number;
    exitGraceMinutes: number;
    freeSessionMaxMinutes: number;
    extendMaxMinutes: number;
    checkBenefitZone: boolean;
    ignoreZoneOnPayment: boolean;
    storageDays: number;
    qcWindowFixationsMinutes: number;
    qcWindowSessionsMinutes: number;
    checkReservationZone: boolean;
    checkReservationDaily: boolean;
    detectRadiusExactM: number;
    detectRadiusInexactM: number;
    enforceSameCamera: boolean;
    paymentSystemType: PaymentSystemSettingEnum;
    cardEnabled: boolean;
  };
  coddRequisites: ICoddRequisites;
}

export interface ICoddRequisites {
  address: string;
  bankName: string;
  beneficiaryName: string;
  bik: string;
  bin: string;
  executorName: string;
  iik: string;
  kbe: string;
  paymentCode: string;
  phone: string;
  vatRate: number;
}

export enum PaymentSystemSettingEnum {
  PREPAID = 'prepaid',
  POSTPAID = 'postpaid',
}
